<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  methods: {
  },
  created() {},
  mounted() {
  }
};
</script>
<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: "微软雅黑";
  color: #e1e2e4;
  font-size: 14px;
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 1.25rem;
  z-index: 99;
}
</style>


// WEBPACK FOOTER //
// src/App.vue